import { FiltersValue } from "./types";

export function defaultFilters(): FiltersValue {
  return {
    keyword: "",
    experience_level: undefined,
    salary: {
      period: "Hourly",
      currency: "USD"
    }
  };
}
